/**
 * Window event `initPostHog()` dispatches once its `loaded` callback has
 * settled consent, so `lib/analytics.ts` can replay the captures it held
 * while the SDK was still uninitialized. Lives in its own module because
 * `@/lib/posthog` is `vi.mock`ed with hand-written factories across the
 * test suite, which would not carry a new export.
 */
export const POSTHOG_LOADED_EVENT = "ahead:posthog-loaded"

/**
 * Window property set together with the event, for code that subscribes after
 * the event has already fired (a lazily loaded chunk, a component that mounts
 * late). `posthog.__loaded` is not a substitute: posthog-js sets it at the very
 * start of `init()`, before the SDK can send anything and before `loaded` has
 * applied the consent opt-out.
 */
const READY_PROPERTY = "__aheadPostHogReady"

/** Mark PostHog ready and tell the listeners. Called once, from `loaded`. */
export function markPostHogReady(): void {
  if (typeof window === "undefined") return
  ;(window as unknown as Record<string, unknown>)[READY_PROPERTY] = true
  window.dispatchEvent(new Event(POSTHOG_LOADED_EVENT))
}

/** Whether `initPostHog()`'s `loaded` callback has run on this page. */
export function isPostHogReady(): boolean {
  if (typeof window === "undefined") return false
  return (window as unknown as Record<string, unknown>)[READY_PROPERTY] === true
}
